module.exports = __webpack_public_path__ + "static/media/kids_47.5ce4f233.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/kids/JPEG/kids_47.jpg
// module id = 5903
// module chunks = 0